// import { routerReducer } from 'react-router-redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import {
  createStore,
  combineReducers,
  applyMiddleware,
  StoreEnhancer,
  compose,
} from 'redux'
import { createEpicMiddleware } from 'redux-observable'
import createLogger from 'redux-logger'
import auth from './auth.reducer'
import header from './header.reducer'
import app from './app.reducer'
import report from './report.reducer'
import inquiry from './inquiry.reducer'
import patient from './patient.reducer'
import epics from '../epics'
import history from '../components/utils/history'

const loggerMiddleware = createLogger
let middleware: StoreEnhancer
const epicMiddleware = createEpicMiddleware()
const rooterMiddleware = routerMiddleware(history)
let enhancer: any
if (process.env.NODE_ENV !== 'production') {
  // 開発.
  const composeEnhancers =
    // tslint:disable-next-line: no-string-literal
    (window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] as typeof compose) ||
    compose
  middleware = applyMiddleware(
    epicMiddleware,
    loggerMiddleware,
    rooterMiddleware
  )
  enhancer = composeEnhancers(middleware)
} else {
  // 製品版はログを使わない.
  middleware = applyMiddleware(epicMiddleware, rooterMiddleware)
  enhancer = middleware
}

const configureStore = () => {
  const store = createStore(
    combineReducers({
      app,
      report,
      inquiry,
      patient,
      auth,
      header,
      routing: connectRouter(history),
    }),
    enhancer
  )
  epicMiddleware.run(epics)
  return store
}

export default configureStore



// WEBPACK FOOTER //
// ./src/reducers/index.ts